export default __webpack_public_path__ + "static/media/Media.972ec208.png";